import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import { useParams } from "react-router-dom";
import SuperAdminPanel from "../panel/SuperAdminPanel";
import "../styles/SuperAdminModulesPage.css";

export default function SuperAdminModulesPage() {
  const { superAdminId } = useParams();
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const token = localStorage.getItem("token");

  // ✅ Fetch all schools for dropdown
  const fetchSchools = async () => {
    try {
      const res = await api.get("/api/superadmin/schools", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSchools(res.data);
    } catch (err) {
      console.error("Error fetching schools:", err);
    }
  };

  // ✅ Fetch modules of selected school
  const fetchModules = async (schoolId) => {
    if (!schoolId) return;
    setLoading(true);
    try {
      const res = await api.get(`/api/modules/${schoolId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModules(res.data);
    } catch (err) {
      console.error("Error fetching modules:", err);
      setModules([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Toggle module enable/disable
  const toggleModule = async (schoolModuleId, enabled) => {
    try {
      await api.post("/api/modules/update", {
        schoolModuleId,
        enabled: enabled ? 0 : 1
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModules((prev) =>
        prev.map((m) =>
          m.school_module_id === schoolModuleId ? { ...m, enabled: enabled ? 0 : 1 } : m
        )
      );
    } catch (err) {
      console.error("Error updating module:", err);
    }
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  return (
    <>
      <SuperAdminPanel onToggle={setIsSidebarCollapsed} />

      <div className={`superadmin-main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <div className="superadmin-topbar">
          <span className="superadmin-date">TODAY IS {new Date().toLocaleString()}</span>
          <span className="superadmin-school">School ERP</span>
        </div>

        <h2 className="superadmin-welcome">Manage School Modules</h2>

        {/* ✅ School selector */}
        <div className="superadmin-section">
          <label>Select School:</label>
          <select
            value={selectedSchool}
            onChange={(e) => {
              setSelectedSchool(e.target.value);
              fetchModules(e.target.value);
            }}
          >
            <option value="">-- Select School --</option>
            {schools.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>

        {/* ✅ Modules Table */}
        <div className="superadmin-modules-table">
          {loading ? (
            <p>Loading modules...</p>
          ) : modules.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Role</th>
                  <th>Module Name</th>
                  <th>Path</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {modules.map((mod) => (
                  <tr key={mod.school_module_id}>
                    <td>{mod.role}</td>
                    <td>{mod.name}</td>
                    <td>{mod.path}</td>
                    <td>{mod.enabled ? "Enabled" : "Disabled"}</td>
                    <td>
                      <button onClick={() => toggleModule(mod.school_module_id, mod.enabled)}>
                        {mod.enabled ? "Disable" : "Enable"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            selectedSchool && <p>No modules found for this school.</p>
          )}
        </div>
      </div>
    </>
  );
}
